import { InputField } from '@components/forms/InputField'
import { NumberField } from '@components/forms/NumberField'
import { SelectButton } from '@features/profile/components/SelectButton'
import { UploadFile } from '@features/profile/components/UploadFile'
import { WriterEnum } from '@interfaces/WriterEnum'
import { AffiliationEnum } from '@interfaces/AffiliationEnum'
import { ErrorIcon } from '@components/icons/ErrorIcon'
import { WriterInformationProps } from './interface'

const writerTypeOptions = [
  { text: 'บุคคล', value: WriterEnum.INDIVIDUAL },
  { text: 'นิติบุคคล', value: WriterEnum.LEGAL },
]

const affiliationOptions = [
  { text: 'สำนักพิมพ์', value: AffiliationEnum.PUBLISHER },
  { text: 'นักเขียน', value: AffiliationEnum.INDIVIDUAL },
]

export function WriterInformation({
  values,
  showErrorMessage,
}: WriterInformationProps) {
  return (
    <div>
      <h2 className='font-mitr text-[24px] ladding-[1.5] font-medium text-secondary dark:text-dark-10 '>
        ข้อมูลนักเขียน
      </h2>
      <div className='grid grid-cols-3 tablet:grid-cols-2 mobile:grid-cols-1 gap-[20px] mt-[20px] mobile:mt-[10px]'>
        <SelectButton name='type' label='ประเภท' options={writerTypeOptions} />
        <SelectButton
          name='affiliation'
          label='สังกัด'
          options={affiliationOptions}
        />
        {values.type === WriterEnum.INDIVIDUAL ? (
          <>
            <div className='col-start-1 col-end-2'>
              <InputField
                name='fullName'
                label='ชื่อ - นามสกุล'
                placeholder='กรอกชื่อ - นามสกุล'
                showErrorMsg={false}
              />
            </div>
            <div>
              <NumberField
                name='idNumber'
                label='รหัสประจำตัวประชาชน'
                placeholder='กรอกไม่เว้นวรรค และไม่ใส่ขีด (-)'
                maxLength={13}
                showErrorMsg={false}
              />
              {showErrorMessage && (
                <div className='flex items-center justify-end mt-[5px]'>
                  <div className='flex items-center text-[12px] text-red-3'>
                    <ErrorIcon className='pr-[5px]' width='36' height='36' />
                    รหัสประจำตัวประชาชนนี้ถูกแบนถาวร
                  </div>
                </div>
              )}
            </div>
            <InputField
              name='email'
              label='อีเมล'
              placeholder='email@example.com'
              type='email'
              showErrorMsg={false}
            />
            <NumberField
              name='phoneNumber'
              label='เบอร์โทรศัพท์'
              placeholder='(+66) กรอกเบอร์โทรศัพท์'
              type='tel'
              maxLength={10}
              showErrorMsg={false}
            />
          </>
        ) : (
          <>
            <div className='col-start-1 col-end-2'>
              <InputField
                name='companyName'
                label='ชื่อบริษัท'
                placeholder='กรอกชื่อบริษัท'
                showErrorMsg={false}
              />
            </div>
            <div>
              <NumberField
                name='taxId'
                label='เลขประจำตัวผู้เสียภาษี'
                placeholder='กรอกไม่เว้นวรรค และไม่ใส่ขีด (-)'
                maxLength={13}
                showErrorMsg={false}
              />
              {showErrorMessage && (
                <div className='flex items-center justify-end mt-[5px]'>
                  <div className='flex items-center text-[12px] text-red-3'>
                    <ErrorIcon className='pr-[5px]' width='36' height='36' />
                    เลขประจำตัวผู้เสียภาษีนี้ถูกแบนถาวร
                  </div>
                </div>
              )}
            </div>
            <div className='col-start-1 col-end-2'>
              <UploadFile
                name='companyCertificateImgPath'
                label='หนังสือรับรอง (ไฟล์ pdf, ไฟล์ภาพ jpg หรือ png)'
                acceptTypes='application/pdf,image/jpeg,image/png'
              />
            </div>
            <UploadFile
              name='vatRegistrationCertificateImgPath'
              label='ภพ 20 (ไฟล์ pdf, ไฟล์ภาพ jpg หรือ png)'
              acceptTypes='application/pdf,image/jpeg,image/png'
            />
          </>
        )}
      </div>
    </div>
  )
}
